import { render, staticRenderFns } from "./DocuExpedienteBuscar.vue?vue&type=template&id=30522248&scoped=true"
import script from "./DocuExpedienteBuscar.vue?vue&type=script&lang=js"
export * from "./DocuExpedienteBuscar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30522248",
  null
  
)

export default component.exports